import { AutocompleteWithItems } from "@similarweb/ui-components";
import {
    DropdownWrapper,
    IndustryTitle,
    StyledSelectedItemsCount,
    WebsiteDropdownTitleWrapper,
    WebsitesDropdownTitle,
} from "./styles";
import WebsitesDropdown from "./components/WebsitesDropdown/WebsitesDropdown";
import { translate } from "app/filters/i18nFilter";
import useIndustries from "./hooks/useIndustries";
import {
    IDUSTRY_PLACEHOLDER_SIZE,
    MARKET_ANALISIS_AUTOCOMPLITE,
    MAX_INDUSTRY_SELECTED,
    MAX_ITEMS_SELECTED,
} from "./constants";
import { DotsLoader } from "@similarweb/ui-components";
import { DropdownContainer } from "../segments/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";

const MarketAnalysisDropdowns = ({ customDashboard }) => {
    const {
        websitesSearch,
        selectedIndustryChip,
        getIndustriesItems,
        selectedDomainItems,
        domainListItems,
        onDomainSelect,
        isSegmentsLoading,
    } = useIndustries(customDashboard);

    return (
        <DropdownWrapper>
            <WebsiteDropdownTitleWrapper>
                <IndustryTitle>{translate("common.industry")}</IndustryTitle>
                <StyledSelectedItemsCount isMaxReached={false}>
                    {`${selectedIndustryChip.length || 0}/${MAX_INDUSTRY_SELECTED}`}
                </StyledSelectedItemsCount>
            </WebsiteDropdownTitleWrapper>
            <AutocompleteWithItems
                floating
                zIndex={MARKET_ANALISIS_AUTOCOMPLITE.Z_INDEX}
                selectedItems={selectedIndustryChip}
                disabled={!!selectedIndustryChip.length || isSegmentsLoading}
                getListItems={getIndustriesItems}
                maxResults={MARKET_ANALISIS_AUTOCOMPLITE.MAX_RESULTS}
                debounce={MARKET_ANALISIS_AUTOCOMPLITE.DEBOUNCE}
                placeholder={translate("dashboard.metricGallery.Website.MarketShares.industries.placeholder")}
                loadingComponent={<DotsLoader />}
            />
            <WebsiteDropdownTitleWrapper>
                <WebsitesDropdownTitle>{translate("wizard.market.analysis.dropdown.title")}</WebsitesDropdownTitle>
                <StyledSelectedItemsCount isMaxReached={selectedDomainItems.size >= MAX_ITEMS_SELECTED}>
                    {`${selectedDomainItems.size || 0}/${MAX_ITEMS_SELECTED}`}
                </StyledSelectedItemsCount>
            </WebsiteDropdownTitleWrapper>
            {!isSegmentsLoading ? (
                <WebsitesDropdown
                    selectedItems={selectedDomainItems.ids}
                    items={domainListItems}
                    setSelectedItem={onDomainSelect}
                    selectedIdsCount={selectedDomainItems.size}
                    searchFilter={websitesSearch}
                    placeholder={"dashboard.metricGallery.Website.MarketShares.website.placeholder"}
                    searchPlaceHolder={"dashboard.metricGallery.Website.MarketShares.website.search.placeholder"}
                    maxItemsSelectedLimit={MAX_ITEMS_SELECTED}
                />
            ) : (
                <DropdownContainer>
                    <PixelPlaceholderLoader
                        width={"100%"}
                        height={IDUSTRY_PLACEHOLDER_SIZE.heigth}
                    />
                </DropdownContainer>
            )}
        </DropdownWrapper>
    );
};

export default MarketAnalysisDropdowns;
